<template>
  <transition name="fade">
    <div class="loaderWrapper" :style="{ background: color }">
      <v-progress-circular
        indeterminate
        :size="size"
        color="#c1c1c1"
      >
      </v-progress-circular>
    </div>
  </transition>
</template>

<script>
/*
  Tip: This loader works better when its parent has
  position relative.
*/
export default {
  name: "FullcreenLoader",
  props: {
    size: {
      type: Number,
      default: 50,
    },
    color: {
      type: String,
      default: "#F2F4F966",
    },
  },
};
</script>

<style scoped>
.loaderWrapper {
  position: absolute;
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.8s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>